export interface ReplaceText {
    findText: string;
    replaceText: string;
}
  